import { useApi } from '../api-provider';
import { useConfiguration } from '../context/configuration-context/use-configuration';
export const useCommentHistory = ({ commentId }) => {
    const { resourceId } = useConfiguration();
    const { commentState, fetchInitialHistory, fetchNextHistory } = useApi((state, actions) => ({
        commentState: state.comments[resourceId],
        fetchInitialHistory: actions.fetchInitialHistory,
        fetchNextHistory: actions.fetchNextHistory,
    }));
    return {
        fetchHistory: () => {
            if ((commentState === null || commentState === void 0 ? void 0 : commentState.type) === 'READY' && commentId) {
                fetchInitialHistory({ commentId, resourceId });
            }
        },
        fetchNextHistory: () => {
            if ((commentState === null || commentState === void 0 ? void 0 : commentState.type) === 'READY' && commentId) {
                fetchNextHistory({ commentId, resourceId });
            }
        },
        getState: () => {
            if ((commentState === null || commentState === void 0 ? void 0 : commentState.type) === 'READY' && commentId) {
                const commentHistoryState = commentState.historyById[commentId];
                if (commentHistoryState === null || commentHistoryState === void 0 ? void 0 : commentHistoryState.items.length) {
                    return {
                        type: 'READY',
                        items: commentHistoryState.items,
                        cursor: commentHistoryState.nextCursor,
                        isFetchingNext: commentHistoryState === null || commentHistoryState === void 0 ? void 0 : commentHistoryState.isPending,
                    };
                }
                if ((commentHistoryState === null || commentHistoryState === void 0 ? void 0 : commentHistoryState.isPending) === true && commentHistoryState.items.length === 0) {
                    return {
                        type: 'INITIAL_FETCH',
                    };
                }
            }
            return { type: 'NOT_READY' };
        },
    };
};
//# sourceMappingURL=use-comment-history.js.map